export default "__VITE_ASSET__BqYiu5D$__"